<template>
  <div>
    <div
      v-if="isOpen && isActive && infoBar.content"
      :class="[
        'info-bar',
        color && `bg-${color}`,
        modulaStyle && 'modulaInfoBar',
      ]"
    >
      <cms-renderer class="hint-text" :markdown="infoBar.content" />
      <span class="close-btn" @click="closeHint" />
    </div>
  </div>
</template>

<script>
import InfoBarQuery from '~/domains/application/__gql__/queries/infoBar.gql'
import {
  PORTALS_ALL,
  PORTALS_CUSTOMER,
  PORTALS_LAWYER,
  PORTALS_LOGIN,
  PORTALS_PARTNER,
  sortInfobarsByProjectScopeOrder,
} from '~/domains/application/cms/projectScopes'

const CmsRenderer = () => import('~/components/DX-CMSRenderer')

export default {
  name: 'InfoBar',
  components: {
    CmsRenderer,
  },
  props: {
    modulaStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: true,
      infoBar: {
        content: '',
        projectScope: '',
        color: '',
      },
      environment: process.env.DEXTRA_ENV,
    }
  },
  computed: {
    currentPortal() {
      return this.$store.state.authentication.currentPortal
    },
    projectScope() {
      switch (this.currentPortal) {
        case 'BROKER_PORTAL':
          return PORTALS_PARTNER
        case 'LAWYER_PORTAL':
          return PORTALS_LAWYER
        case 'CUSTOMER_CENTER':
          return PORTALS_CUSTOMER
        default:
          return null
      }
    },
    isActive() {
      if (!this.infoBar) return false
      const { startDate, endDate } = this.infoBar
      const today = new Date().getTime()
      const hasStarted = today > new Date(startDate).getTime()
      const hasNotEnded = endDate ? today < new Date(endDate).getTime() : true
      return startDate && hasStarted && hasNotEnded
    },
    color() {
      return this.infoBar.color ? this.infoBar.color.toLowerCase() : 'black'
    },
  },
  watch: {
    'currentPortal': function (newPortal) {
      if (newPortal && this.projectScope) {
        this.isOpen = true
        this.fetchInfoBar(this.projectScope)
        // close portal-specific message for logged out user
      } else if (!newPortal && this.infoBar.projectScope !== PORTALS_ALL) {
        this.isOpen = false
      }
    },
    '$i18n.locale': async function refetchInfoBar() {
      await this.fetchInfoBar(this.projectScope)
    },
  },
  async mounted() {
    // user is already logged in and opens url directly
    if (this.currentPortal) {
      await this.fetchInfoBar(this.projectScope)
    } else {
      await this.fetchInfoBar(PORTALS_LOGIN)
    }
  },
  methods: {
    closeHint() {
      this.isOpen = !this.isOpen
    },

    async fetchInfoBar(additionalProjectScope) {
      try {
        const { data } = await this.$apollo.query({
          query: InfoBarQuery,
          client: 'cms',
          fetchPolicy: 'network-only',
          variables: {
            additionalProjectScope,
          },
        })
        if (data && data.infoBars) {
          this.processResult(data.infoBars)
        }
      } catch (e) {
        console.error(e)
      }
    },

    resetInfoBar() {
      this.infoBar = {
        content: '',
        projectScope: '',
        color: '',
      }
    },

    processResult(infoBars) {
      const sortedInfoBars = sortInfobarsByProjectScopeOrder(infoBars)

      if (sortedInfoBars.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.infoBar = sortedInfoBars[0]
      } else {
        this.resetInfoBar()
      }
    },
  },
}
</script>

<style lang="scss">
@import 'index';
</style>
